module.exports = __webpack_public_path__ + "static/media/logo.c00e70b1.png";